/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface EnrollmentCalendarItem
 */
export interface EnrollmentCalendarItem {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof EnrollmentCalendarItem
     */
    enrollmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof EnrollmentCalendarItem
     */
    memberId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof EnrollmentCalendarItem
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentCalendarItem
     */
    studentName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof EnrollmentCalendarItem
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentCalendarItem
     */
    className: string;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentCalendarItem
     */
    status: string;
    /**
     * 
     * @type {Date}
     * @memberof EnrollmentCalendarItem
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentCalendarItem
     */
    locationName: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrollmentCalendarItem
     */
    teacherName: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof EnrollmentCalendarItem
     */
    teacherId: ActorActivityRecordActorUserId | null;
}

/**
 * Check if a given object implements the EnrollmentCalendarItem interface.
 */
export function instanceOfEnrollmentCalendarItem(value: object): value is EnrollmentCalendarItem {
    if (!('enrollmentId' in value) || value['enrollmentId'] === undefined) return false;
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('teacherName' in value) || value['teacherName'] === undefined) return false;
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    return true;
}

export function EnrollmentCalendarItemFromJSON(json: any): EnrollmentCalendarItem {
    return EnrollmentCalendarItemFromJSONTyped(json, false);
}

export function EnrollmentCalendarItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentCalendarItem {
    if (json == null) {
        return json;
    }
    return {
        
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['enrollmentId']),
        'memberId': ApiUserTasksGetPageParameterFromJSON(json['memberId']),
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'status': json['status'],
        'date': (new Date(json['date'])),
        'locationName': json['locationName'],
        'teacherName': json['teacherName'],
        'teacherId': ActorActivityRecordActorUserIdFromJSON(json['teacherId']),
    };
}

export function EnrollmentCalendarItemToJSON(json: any): EnrollmentCalendarItem {
    return EnrollmentCalendarItemToJSONTyped(json, false);
}

export function EnrollmentCalendarItemToJSONTyped(value?: EnrollmentCalendarItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['enrollmentId']),
        'memberId': ApiUserTasksGetPageParameterToJSON(value['memberId']),
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'status': value['status'],
        'date': value['date'].toISOString(),
        'locationName': value['locationName'],
        'teacherName': value['teacherName'],
        'teacherId': ActorActivityRecordActorUserIdToJSON(value['teacherId']),
    };
}

